import {
	AfterViewInit,
	Component,
	ElementRef,
	EventEmitter,
	inject,
	Input,
	OnChanges,
	OnDestroy,
	Output,
	SimpleChanges,
	ChangeDetectionStrategy,
} from '@angular/core';
import { fromEvent, Subject } from 'rxjs';
import { distinctUntilChanged, map, takeUntil } from 'rxjs/operators';
import { User } from '@lmc-app/shared/interface/user.interface';
import { MatIcon } from '@angular/material/icon';
import { MatTabGroup, MatTab, MatTabContent } from '@angular/material/tabs';
import { WorkdriveComponent } from './workdrive/workdrive.component';
import { BankingComponent } from './banking/banking.component';
import { PandadocComponent } from './pandadoc/pandadoc.component';
import { DocusignComponent } from '../docusign/docusign.component';

@Component({
	selector: 'app-fulfillment',
	templateUrl: './fulfillment.component.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: ['./fulfillment.component.scss'],
	imports: [
		MatIcon,
		MatTabGroup,
		MatTab,
		MatTabContent,
		WorkdriveComponent,
		BankingComponent,
		PandadocComponent,
		DocusignComponent,
	],
})
export class FulfillmentComponent
	implements OnChanges, AfterViewInit, OnDestroy
{
	@Input() application: any;
	@Output() applicationChange = new EventEmitter();
	@Input() currentUser: User;
	@Output() currentUserChange = new EventEmitter();
	protected isScrolled = false;
	private readonly _onDestroy = new Subject<void>();
	private readonly _elementRef = inject<ElementRef<HTMLElement>>(ElementRef);

	constructor() {}

	ngOnChanges(changes: SimpleChanges) {
		this.application = changes.application?.currentValue;
		if (changes.currentUser?.currentValue) {
			this.currentUser = changes.currentUser?.currentValue;
		}
	}

	ngAfterViewInit(): void {
		// Show the header bar shadow only once the summary content has scrolled
		const scrollContainer = this._elementRef.nativeElement.closest(
			'.scrollable-content'
		);
		if (!scrollContainer) {
			return;
		}
		fromEvent(scrollContainer, 'scroll', { passive: true })
			.pipe(
				map(() => scrollContainer.scrollTop > 0),
				distinctUntilChanged(),
				takeUntil(this._onDestroy)
			)
			.subscribe((isScrolled) => (this.isScrolled = isScrolled));
	}

	ngOnDestroy(): void {
		this._onDestroy.next();
		this._onDestroy.complete();
	}

	onApplicationChanged(application: any) {
		this.applicationChange.emit(application);
	}
}
